var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6154 2.36731C23.7103 2.76877 22.7357 3.04022 21.7148 3.16308C22.7574 2.53732 23.5582 1.54868 23.9348 0.370026C22.9587 0.948639 21.8784 1.36867 20.7271 1.5944C19.8061 0.612901 18.4941 0 17.0416 0C14.2525 0 11.9906 2.26016 11.9906 5.04893C11.9906 5.4461 12.0369 5.83042 12.1223 6.20044C7.92564 5.99043 4.20538 3.97886 1.71459 0.924352C1.2787 1.67012 1.03107 2.53732 1.03107 3.4631C1.03107 5.21466 1.92312 6.76048 3.27713 7.66483C2.44879 7.63912 1.6697 7.41196 0.990524 7.03336C0.990524 7.05479 0.990524 7.07622 0.990524 7.09765C0.990524 9.54354 2.72973 11.5837 5.04096 12.048C4.61665 12.1637 4.17207 12.2252 3.71012 12.2252C3.38574 12.2252 3.0686 12.1937 2.76014 12.1337C3.40312 14.1396 5.26831 15.5997 7.47816 15.6411C5.74909 16.9941 3.5711 17.8013 1.20485 17.8013C0.797922 17.8013 0.395341 17.7784 0 17.7313C2.23447 19.1642 4.8889 20 7.74173 20C17.0301 20 22.1101 12.3066 22.1101 5.63469C22.1101 5.41467 22.1043 5.19894 22.0956 4.98178C23.0818 4.27031 23.9391 3.38024 24.6154 2.36874V2.36731Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterWhite);
export default __webpack_public_path__ + "static/media/twitterWhite.af5e88f60523cdff9d749859c920dad8.svg";
export { ForwardRef as ReactComponent };